export enum ApiPaymentsField {
  CashbackAmount = 'cashback_amount',
  CashbackCount = 'cashback_count',
  PaymentAmount = 'sum_payment_amount',
  PaymentAmountNoCashback = 'payment_amount_no_cashback',
  PaymentCount = 'sum_payment_count',
  PaymentCountNoCashback = 'payment_count_no_cashback',
  PaymentMethod = 'payment_label', // inverted with payment_type in IOS
}

export enum ApiPaymentsAggregate {
  PaymentMethod = 'paymentLabel',
}
